import { PaginationFilterRequest } from "./core.model";

export interface AdvanceSharePack {
    id: number;
    title: string;
    coverUrl?: string;
    status: AdvanceSharePackStatusEnum;
}

export interface UpsertAdvanceSharePack {
    id?: number;
    title?: string;
    coverUrl?: string;
    status?: AdvanceSharePackStatusEnum;
}

export interface AdvanceSharePackItem {
    id: number;
    imageUrl: string;
}

export interface UpsertAdvanceSharePackItem {
    id?: number;
    packId: number;
    imageUrl: string;
}

export class AdvanceSharePackPaginationFilterRequest extends PaginationFilterRequest {
    status?: AdvanceSharePackStatusEnum;
}

export class AdvanceSharePackItemPaginationFilterRequest extends PaginationFilterRequest {
    packId?: number;
}

export enum AdvanceSharePackStatusEnum {
    Draft = 1,
    Published = 2,
    Archived = 3,
}

export const AdvanceSharePackStatusList =
[
    { value: 1, label: "Draft" },
    { value: 2, label: "Published" },
    { value: 3, label: "Archived" },
];
